enum HousingTenureEnum {
    HOME_OWNERSHIP = "HOME_OWNERSHIP",
    PRIVATE_RENTING = "PRIVATE_RENTING",
    LIVING_WITH_PARENTS = "LIVING_WITH_PARENTS",
    COMMONHOLD = "COMMONHOLD",
    PUBLIC_HOUSING = "PUBLIC_HOUSING",
}

export default HousingTenureEnum;
